/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { ApiParameter, get, HasPagingParameters } from "@insite/client-framework/Services/ApiService";

// export interface GetKnowledgeCenterApiParameter extends ApiParameter, HasPagingParameters {

// }
export interface KnowledgeCenterModel {
    pageSize?: number;
    page?: number;
    documentType?: string[];
    productCategory?: string[];
    productBrand?: string[];
}
export interface GetKnowledgeCenterApiParameter extends ApiParameter {
    params: KnowledgeCenterModel;
}

const KnowledgeCenterAPIUrl = "api/custom/documents/getDocumentWithFacets";

export function getKnowledgeCenterItems(parameter: GetKnowledgeCenterApiParameter) {
    const additionalQueryStringParametersTemp = parameter?.params;
    return get<any>(`${KnowledgeCenterAPIUrl}`, {
        additionalQueryStringParameters: additionalQueryStringParametersTemp,
    });
}
const KnowledgeCenterDetailsAPIUrl = "api/custom/documents/getDocument";

export function getKnowledgeCenterDetails(parameter: any) {
    if(!parameter.params) {
        return;
    }
    const { id } = parameter.params;
    return get<any>(`${KnowledgeCenterDetailsAPIUrl}/${id}`);
}
